import React, { useEffect, useState } from "react";

function Title({ query }) {
  const [titles, setTitles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const path = query;
    fetch(path)
      .then((res) => res.json())
      .then((data) => {
        setTitles(data.Titles || []);
        setLoading(false); // ✅ done loading
      })
      .catch((err) => {
        console.error(err);
        setLoading(false); // ✅ stop loading on error
      });
  }, [query]);
  return (
    <div>
      {loading && <p>Loading Recommendations...</p>}
      {!loading && titles.length === 0 && <p>No Title Information</p>}
      {!loading &&
        titles.length > 0 &&
        titles.map((title) => (
          <div
            key={title.imdb_id || title.title} // ✅ use unique key if possible
            style={{
              border: "1px solid #ccc",
              margin: "1rem 0",
              padding: "1rem",
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {/* Poster */}
            <div
              style={{
                flex: "1 1 20%",
                maxWidth: "20%",
                minWidth: "250px",
                boxSizing: "border-box",
                paddingRight: "1rem",
              }}
            >
              <img
                loading="lazy"
                src={title.imdb_poster}
                alt={title.title || "Movie Poster"} // ✅ better alt text
                style={{ width: "100%", height: "auto", display: "block" }}
              />
            </div>

            {/* Info */}
            <div
              style={{
                flex: "1 1 45%",
                maxWidth: "45%",
                minWidth: "250px",
                boxSizing: "border-box",
                fontSize: "clamp(0.9rem, 2vw, 1.1rem)",
              }}
            >
              <h3>{title.title}</h3>
              <p>
                <strong>Genre:</strong> {title.genre}
              </p>
              <p>
                <strong>MPAA Rating:</strong> {title.mpaa}
              </p>
              <p>
                <strong>Distributors:</strong> {title.dist}
              </p>
            </div>
          </div>
        ))}
    </div>
  );
}

export default Title;
